import React, { useState, useEffect, useCallback } from 'react';
import commonMethod from '../../lib/commonMethod';
import CloseIcon from '../../assets/img/dashboard/iconClose';
import cookie from 'react-cookies';
import CameraShutterIcon from '../../assets/img/dashboard/cameraShutter';
import DeviceType from './DeviceType';
import LightType from './panel/light';
import AirConditionType from './panel/aircondition';
import FanType from './panel/fan';
import TVRemoteType from './panel/tvRemote';
import SwitchType from './panel/switch';
import RelayType from './panel/relay';
import PlugType from './panel/plug';
import PurifierType from './panel/purifier';
import CurtainType from './panel/curtain';
import BlindType from './panel/blind';
import PowerStripType from './panel/powerStrip';
import AlarmType from './panel/alarm';
import RefSensorType from './panel/refSensor';
import PowerIconLarge from '../../assets/img/dashboard/powerLarge';

const DeviceSetting = ({ closePanel, selectedItem, demo }) => {
  const [action, setAction] = useState(false);
  const accessToken = cookie.load('accessToken');
  const [item, setItem] = useState(null);

  useEffect(() => {
    if (item !== selectedItem) {
      setItem(selectedItem);
    }
  }, [item, selectedItem]);

  const handleAction = useCallback(() => {
    setAction(true);
    setTimeout(() => {
      setAction(false);
    }, 300);
  }, []);

  const handlePower = useCallback(() => {
    let newItem = item;
    let url = 'dashboard/control/';
    handleAction();
    if (
      item &&
      item.online &&
      item.deviceType !== 'SensorTh' &&
      item.deviceType !== 'SensorDo'
    ) {
      let data = {
        requirments: {
          power: true
        }
      };
      if (item.deviceType.indexOf('Switch') !== -1) {
        // 스위치인 경우
        let isOn = false;
        for (var key in item.deviceState) {
          if (item.deviceState[key]) {
            isOn = true;
          }
        }
        let switchCount = Number(item.deviceType.split('Switch')[1]);
        let requirments = {};
        for (let i = 1; i < switchCount + 1; i++) {
          Object.assign(requirments, { ['power' + i]: !isOn });
        }
        data.requirments = requirments;
        newItem.deviceState = requirments;
      } else if (item.deviceType.indexOf('Airconditioner') !== -1) {
        // 커튼인 경우
        if (item.deviceState && item.deviceState.power === '켜짐') {
          data.requirments = { power: 'false' };
          newItem.deviceState.power = '꺼짐';
        } else {
          data.requirments = { power: 'true' };
          newItem.deviceState.power = '켜짐';
        }
      } else if (item.deviceType.indexOf('Curtain') !== -1) {
        // 커튼인 경우
        if (item.deviceState && item.deviceState.control === 'open') {
          data.requirments = { control: 'close' };
          newItem.deviceState.control = 'close';
        } else {
          data.requirments = { control: 'open' };
          newItem.deviceState.control = 'open';
        }
      } else if (item.deviceState && item.deviceState.power === 'true') {
        data.requirments.power = 'false';
        newItem.deviceState.power = 'false';
      } else if (item.deviceState && item.deviceState.power === 'false') {
        data.requirments.power = 'true';
        newItem.deviceState.power = 'true';
      } else if (
        item.deviceState &&
        (item.deviceState.power === true ||
          item.deviceState.power === false ||
          item.deviceState.power === 'true' ||
          item.deviceState.power === 'false')
      ) {
        // on, off가 가능한 제품 상태 변경
        data.requirments.power = !item.deviceState.power;
        newItem.deviceState.power = !item.deviceState.power;
      } else if (
        item.deviceType.indexOf('Ir') !== -1 &&
        item.deviceType !== 'IrAirconditioner'
      ) {
        data.requirments = { power: true };
        newItem['animation'] = true;
      } else if (
        item.deviceType === 'RelayController' ||
        item.deviceType === 'RelayController2' ||
        item.deviceType === 'RelayControllerDc' ||
        item.deviceType === 'RelayControllerDc2'
      ) {
        data.requirments = { power1: !item.deviceState.power1 };
        newItem.deviceState = { power1: !item.deviceState.power1 };
      }

      if (demo === true) {
      } else {
        commonMethod.requestPostWithData(
          url + item.id,
          accessToken,
          JSON.stringify(data),
          this,
          res => {
            setItem(item);
          }
        );
      }
    }
  }, [accessToken, demo, handleAction, item]);

  const handlePostData = useCallback(
    (key, data, option) => {
      let newData;
      if (option === 'AllSwitches') {
        newData = { requirments: data };
      } else if (option === 'refSensorManagement') {
        newData = { requirments: data };
      } else if (option === 'Blind') {
        newData = { requirments: { [key]: data } };
      } else if (option === 'alarmSwitch') {
        newData = { requirments: data };
      } else {
        item.deviceState[key] = data;
        newData = { requirments: { [key]: data } };
      }
      if (demo === true) {
      } else {
        commonMethod.requestPostWithData(
          'dashboard/control/' + item.id,
          accessToken,
          JSON.stringify(newData),
          this,
          res => {
            if (key !== 'percentControl') {
              setItem(item);
            }
          }
        );
      }
    },
    [accessToken, demo, item]
  );

  const handleIRPostData = useCallback(
    (key, data) => {
      var newData = { requirments: {} };
      newData.requirments[key] = data;
      if (demo === true) {
      } else {
        commonMethod.requestPostWithData(
          'dashboard/control/' + item.id,
          accessToken,
          JSON.stringify(newData),
          this,
          res => {
            setItem(item);
          }
        );
      }
    },
    [accessToken, demo, item]
  );

  return (
    <div className="device-setting">
      {item && (
        <React.Fragment>
          <section className="device-setting-header">
            <span className={action ? 'on' : 'off'} />
            <h3>{item.name}</h3>
            <p className="close-panel" onClick={closePanel}>
              <CloseIcon />
            </p>
          </section>
          <div className="device-scroll" key={item.id}>
            {DeviceType.light.includes(item.deviceType) && (
              <LightType
                handlePower={handlePower}
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {DeviceType.switch.includes(item.deviceType) && (
              <SwitchType
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {item.deviceType === 'IrAirconditioner' && (
              <AirConditionType
                key={`aircon-${item.id}`}
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {item.deviceType === 'IrFan' && (
              <FanType
                handlePostData={handleIRPostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {(item.deviceType === 'IrSettopbox' ||
              item.deviceType === 'IrTv') && (
              <TVRemoteType
                handlePostData={handleIRPostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {(item.deviceType === 'Relay' ||
              item.deviceType === 'RelayController' ||
              item.deviceType === 'RelayController2' ||
              item.deviceType === 'RelayControllerDc' ||
              item.deviceType === 'RelayControllerDc2') && (
              <RelayType
                handlePower={handlePower}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {(item.deviceType === 'Plug' ||
              item.deviceType === 'SmartPlug' ||
              item.deviceType === 'BruntPlug') && (
              <PlugType
                handlePower={handlePower}
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {(item.deviceType === 'Airpurifier' ||
              item.deviceType === 'IrAirpurifier') && (
              <PurifierType
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {item.deviceType === 'Curtain' && (
              <CurtainType
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {item.deviceType === 'IrCamera' && (
              <section className="device-setting-footer">
                <div className="device-button device-camera-button">
                  <button onClick={() => handleAction()}>
                    <CameraShutterIcon /> 셔터
                  </button>
                </div>
              </section>
            )}
            {item.deviceType === 'IrDIY' && (
              <section className="device-setting-footer">
                <div className="device-button device-diy-button">
                  <button onClick={() => handleAction()}>전원</button>
                  <button onClick={() => handleAction()}>+</button>
                  <button onClick={() => handleAction()}>-</button>
                </div>
              </section>
            )}
            {item.deviceType !== 'IrAirconditioner' &&
              item.deviceType.includes('Ir') && (
                <section className="device-setting-footer">
                  <div className="device-button">
                    <button onClick={handlePower}>
                      <PowerIconLarge /> 전원
                    </button>
                  </div>
                </section>
              )}
            {DeviceType.blind.includes(item.deviceType) && (
              <BlindType
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {DeviceType.powerStrip.includes(item.deviceType) && (
              <PowerStripType
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
                handlePower={handlePower}
              />
            )}
            {item.deviceType === 'AudibleAlarm' && (
              <AlarmType
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
            {item.deviceType === 'SensorRefTh2' && (
              <RefSensorType
                handlePostData={handlePostData}
                action={handleAction}
                selectedItem={item}
              />
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default DeviceSetting;
